import {getAxios,AxiosCategory, getAxiosTotall} from "./ApiInstance"

/////////////////////////////////////// Get Api ////////////////////////////////////////

export const getfoodDiscountApi =(callback)=>{
    getAxiosTotall().get("/promotion/off/limit/food").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getAllfoodDiscountApi =(callback)=>{
    getAxiosTotall().get("/promotion/off/food").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getsuperyDiscountApi =(callback)=>{
    getAxiosTotall().get("/promotion/off/limit/supermarket").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getAllsuperyDiscountApi =(callback)=>{
    getAxiosTotall().get("/promotion/off/supermarket").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getRestaurantCategory =(callback)=>{
    AxiosCategory().get("food/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getUserInfo =(callback)=>{
    getAxios().get("info/").then(response=>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')){
            localStorage.clear()
            //window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
}

export const getFavoriteSup=(callback) => {
    getAxiosTotall().get("user/favorite/supplier/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
};

export const getFavoritePro=(callback) => {
    getAxiosTotall().get("user/favorite/product/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getCommentsSup=(callback) => { 
    getAxios().get("comment/supplier/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getCommentsPro=(callback) => {
    getAxios().get("comment/product/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getPastOrderApi=(callback) => {
    getAxios().get("order/all/?filter=previous").then(response=>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')!==null){
            localStorage.clear()
            window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
}

export const getFactorOrderApi=(orderid,supplierid,callback) => {
    getAxios().get(`order/${orderid}/${supplierid}/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getDiscountApi=(callback) => {
    getAxios().get("discount/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getDeliverLocaApi=(orderId,callback) => {
    getAxios().get(`order/location/?id=${orderId}`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getCategoryApi=(callback) => {
    AxiosCategory().get("/supermarket/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const categoryApi=(category,callback) => {
    AxiosCategory().get(`/${category}/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getProductDetailApi=async(id,callback) => {
    getAxiosTotall().get(`/product/${id}/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getProductDetailApiDependSupplier=(id,supId,callback) => {
    getAxiosTotall().get(`/product/${id}/${supId}/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getLastSeenApi=(callback) => {
    getAxios().get("seen/").then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const GetNewOrderListApi=async(callback) => {
    getAxiosTotall().get('user/order/all/').then(response=>{
        if(response.data.status===-2&&localStorage.getItem('JwtTokens')!==null){
            localStorage.clear()
            window.location.reload()
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
}

export const getFoodGrouping=(category,callback) => {
    AxiosCategory().get(`/${category}/supplier/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const getSearchResultApi=(text,callback) => {
    getAxiosTotall().get(`search/?q=${text}`).then(response=>{
        if(response.data.status===-2){
            localStorage.clear()
            callback(true,response.data)
        }else{
            callback(true,response.data)
        }
    }).catch(error=>{
        callback(false,error)
    })
}

export const getSearchResultAllProductApi=(text,callback) => { 
    getAxiosTotall().get(`search/?qm=${text}`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getSearchFoodApi=(text,callback) => {
    getAxiosTotall().get(`search/?q=${text}&type=food`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getSearchSuperyApi=(text,callback) => {
    getAxiosTotall().get(`search/?q=${text}&type=supermarket`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getSearchSuperyProductApi=(text,supId,callback) => {
    getAxiosTotall().get(`search/?q=${text}&supplier_id=${supId}`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const postGetMicrotransactionApi=(callback) => {
    getAxiosTotall().get('user/info/wallet/').then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const getDeliverInfoApi=(orderId,callback) => {
    getAxios().get(`order/deliveryinfo/?id=${orderId}`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

export const GetVillageListApi=(cityId,callback) => {
    getAxiosTotall().get(`region/${cityId}/`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const messageHandlerAPI=(orderID,callback) => {
    getAxiosTotall().get(`cart/checkorder/${orderID}`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}
export const BarestHelpInfoApi=(callback) => {
    getAxiosTotall().get(`/debt/list`).then(response=>{
        callback(true,response.data)
    }).catch(error=>{
        callback(false,error)
    })
}

// export const getMoreDiscountApi=(callback) => {
//     getAxiosTotall().get("promotion/off/").then(response=>{
//         callback(true,response.data)
//     }).catch(error=>{
//         callback(false,error)
//     })
// }

// export const getMoreDailyOfferApi=(callback) => {
//     getAxiosTotall().get("promotion/daily_offer/").then(response=>{
//         callback(true,response.data)
//     }).catch(error=>{
//         callback(false,error)
//     })
// }

///////////////////////////////// Post Api //////////////////////////////////

export const userPayTaxiApi =(info,call)=>{
    getAxiosTotall().post("taxi/pay/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const reqForBarestHelp =(payload,call)=>{
    getAxiosTotall().post(`/debt/call`, payload).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const payBarestHelpInstallment =(data,call)=>{
    getAxiosTotall().post(`/debt/pay`,data).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const userCancelTaxiApi =(info,call)=>{
    getAxiosTotall().post("taxi/cancel/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const UpdateUserInfo =(info,call)=>{
    getAxios().post("info/update/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}

export const getNotifInfo=(info, callback)=>{
    getAxiosTotall().post("fcm/new/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}

export const sendNotifInfo=(info, callback)=>{
    getAxiosTotall().post("fcm/", info).then(response =>{
        callback(response.data);
    }).catch(error => {
        callback(error.data);
    })
}

export const postAddToFavoriteApi =(info,call)=>{
    getAxios().post("favorite/add/product/", info).then(response =>{
        call(response.data);
    }).catch(error => {
        call(error.data);
    })
}
export const postRemoveFavoriteApi =(info,call)=>{
    getAxios().post("favorite/remove/product/", info).then(response =>{
        call(response.data);
    }).catch(error => {
        call(error.data);
    })
}
export const DiscountCodeApi =(info,call)=>{
    getAxios().post("discount/buy/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const DeletebasketApi =(info,call)=>{
    getAxiosTotall().post("cart/delete/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const postSupportsApi =(info,call)=>{
    getAxiosTotall().post("support/", info).then(response =>{
        call(response.data);
    }).catch(error => {
        call(error.data); 
    })
}
export const AddCommentSup =(info,call)=>{
    getAxios().post("comment/add/supplier/", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}
export const sendOrderProducts =(info,call)=>{
    getAxiosTotall().post("cart/mpay", info).then(response =>{
        call(true,response.data);
    }).catch(error => {
        call(false,error.data);
    })
}